import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ReactComponent as AlarmClockIcon } from '../../icons/alarm-clock.svg';
import './generic-daily-card.scss';

export type SnoozeOption = 'hour' | 'afternoon' | 'tomorrow';

interface GenericDailyCardProps {
  children: React.ReactNode;
  onIgnore?: () => void;
  isIgnoring?: boolean;
  onSnooze?: (option: SnoozeOption) => void;
  isSnoozing?: boolean;
}

const GenericDailyCard: React.FC<GenericDailyCardProps> = ({
  children,
  onIgnore,
  isIgnoring = false,
  onSnooze,
  isSnoozing = false,
}) => {
  const [snoozeOpen, setSnoozeOpen] = useState(false);
  const [showIgnoreConfirm, setShowIgnoreConfirm] = useState(false);

  const handleSnoozeOption = (option: SnoozeOption) => {
    if (onSnooze) {
      onSnooze(option);
    }
    setSnoozeOpen(false);
  };

  const handleIgnoreClick = () => {
    setShowIgnoreConfirm(true);
  };

  const handleIgnoreConfirm = () => {
    setShowIgnoreConfirm(false);
    if (onIgnore) {
      onIgnore();
    }
  };

  const handleIgnoreCancel = () => {
    setShowIgnoreConfirm(false);
  };

  return (
    <div className='generic-daily-card-wrapper'>
      <Modal
        show={showIgnoreConfirm}
        onHide={handleIgnoreCancel}
        centered
        className='ignore-modal'
      >
        <Modal.Body className='ignore-modal-body'>
          <h2>Ignore this item?</h2>
          <p>This item will be removed from your daily list.</p>
          <div className='button-wrapper'>
            <Button
              variant='dark'
              className='ignore-primary-btn'
              onClick={handleIgnoreConfirm}
              disabled={isIgnoring}
            >
              {isIgnoring ? 'Ignoring...' : 'Yes, ignore'}
            </Button>
            <button
              className='ignore-cancel-btn'
              onClick={handleIgnoreCancel}
              disabled={isIgnoring}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className='action-line'>
        <div className='snooze-wrapper'>
          <button
            className='snooze-button'
            onClick={() => setSnoozeOpen(!snoozeOpen)}
            disabled={isSnoozing}
          >
            <AlarmClockIcon />
            {isSnoozing ? 'Snoozing...' : 'Snooze'}
          </button>
          {snoozeOpen && !isSnoozing && (
            <div className='snooze-dropdown'>
              <button onClick={() => handleSnoozeOption('hour')}>
                In an hour
              </button>
              <button onClick={() => handleSnoozeOption('afternoon')}>
                This afternoon
              </button>
              <button onClick={() => handleSnoozeOption('tomorrow')}>
                Tomorrow
              </button>
            </div>
          )}
        </div>
        <button className='ignore-button' onClick={handleIgnoreClick}>
          Ignore
        </button>
      </div>
      <div className='card-main-body-wrapper'>{children}</div>
    </div>
  );
};

export default GenericDailyCard;
